import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

import { ErrorsService } from "../services/common/errors.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ChipsComponent } from "../components/chips/chips.component";
import { TranslateService, TranslateModule } from "@ngstack/translate";
import { SexualityComponent } from "../components/sexuality/sexuality.component";
import { AngularMaterialModule } from "../pages/angular-material/angular-material.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TextMaskModule } from "angular2-text-mask";
import { CountdownModule } from "ngx-countdown";
import { ConfirmComponent } from "../components/confirm/confirm.component";
import { AddressComponent } from "../components/address/address.component";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { AccordionDirective } from "../directive/menu-accordion/accordion.directive";
import { AccordionAnchorDirective } from "../directive/menu-accordion/accordion-anchor.directive";
import { AccordionLinkDirective } from "../directive/menu-accordion/accordion-link.directive";
import { ClickColorDirective } from "../directive/click-color/click-color.directive";
import { ShowActionDirective } from "./show-action.directive";
import { AmazingTimePickerModule } from "amazing-time-picker";
import { CallbackPipe } from '../pipe/callback.pipe';
import { ToJalaliPipe } from "../pipe/to-jalali.pipe";
import { MiniGuideParentDirective } from './mini-guide-parent.directive';
import { MiniGuideDirective } from './mini-guide.directive';
import {OverlayModule} from '@angular/cdk/overlay';
import { MiniGuideComponent } from "../components/mini-guide/mini-guide.component";
import { ErrorComponent } from './components/error/error.component';

@NgModule({
  declarations: [
    SexualityComponent,
    ChipsComponent,
    ConfirmComponent,
    AddressComponent,
    AccordionDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    ClickColorDirective,
    ShowActionDirective,
    CallbackPipe,
    ToJalaliPipe,
    MiniGuideParentDirective,
    MiniGuideDirective,
    MiniGuideComponent,
    ErrorComponent
  ],
  imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    TextMaskModule,
    CountdownModule,
    AmazingTimePickerModule,
    LoadingBarRouterModule,
    PerfectScrollbarModule,
    OverlayModule
  ],
  exports: [
    FormsModule,
    CommonModule,
    RouterModule,
    ChipsComponent,
    TranslateModule,
    FlexLayoutModule,
    SexualityComponent,
    ReactiveFormsModule,
    AngularMaterialModule,
    CountdownModule,
    TextMaskModule,
    LoadingBarRouterModule,
    PerfectScrollbarModule,
    AccordionDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    ClickColorDirective,
    ShowActionDirective,
    AmazingTimePickerModule,
    CallbackPipe,
    ToJalaliPipe,
    MiniGuideParentDirective,
    MiniGuideDirective,
    ErrorComponent,
  ],
  entryComponents: [ConfirmComponent, MiniGuideComponent]
})
export class sharedModule {
  static forRoot() {
    return {
      providers: [TranslateService, ErrorsService]
    };
  }
}
